export const removeWhitespace = str => {
  return str.replace(/\s+/g, '')
}
